import { createAction } from '@reduxjs/toolkit';

export const authResponse = createAction<any>(`/user/auth/request`);
